export const analyticsKeys = {
    all: ['analytics'] as const,
    userActivity: (start: string, end: string) =>
        [...analyticsKeys.all, 'user-activity', start, end] as const,
    retention: (start: string, end: string, segment: string) =>
        [...analyticsKeys.all, 'retention', start, end, segment] as const,
    revenue: (start: string, end: string) =>
        [...analyticsKeys.all, 'revenue', start, end] as const,
    learningSummary: (start: string, end: string) =>
        [...analyticsKeys.all, 'learning-summary', start, end] as const,
    wordbookDetail: (start: string, end: string) =>
        [...analyticsKeys.all, 'wordbook-detail', start, end] as const,
    aiOperations: (start: string, end: string) =>
        [...analyticsKeys.all, 'ai-operations', start, end] as const,
};
